// ===================================
// RESUME API SERVICE - UPDATED
// src/services/resumeApi.js
// Frontend API calls for resume management
// UPDATED: deleteResume now supports force parameter
// ===================================

import api from "./api";

/**
 * Get all user resumes
 */
export const getResumes = async () => {
  const response = await api.get("/resumes");
  return response.data;
};

/**
 * Get single resume details
 */
export const getResume = async (resumeId) => {
  const response = await api.get(`/resumes/${resumeId}`);
  return response.data;
};

/**
 * Get user's primary resume
 */
export const getPrimaryResume = async () => {
  const response = await api.get("/resumes/user/primary");
  return response.data;
};

/**
 * Upload a new resume
 * @param {File} file - Resume file
 * @param {boolean} setPrimary - Set as primary resume
 */
export const uploadResume = async (file, setPrimary = false) => {
  const formData = new FormData();
  formData.append("resume", file);
  formData.append("setPrimary", setPrimary.toString());

  const response = await api.post("/resumes/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

/**
 * Set resume as primary
 */
export const setResumePrimary = async (resumeId) => {
  const response = await api.put(`/resumes/${resumeId}/primary`);
  return response.data;
};

/**
 * Reprocess resume to extract data
 */
export const reprocessResume = async (resumeId) => {
  const response = await api.post(`/resumes/${resumeId}/reprocess`);
  return response.data;
};

/**
 * Delete a resume
 *
 * BEST PRACTICE:
 * - Default (hard=false): Soft delete - hides resume but preserves session references
 * - hard=true: Permanently deletes from database and S3
 * - force=true: Required with hard=true when resume has session references
 *
 * @param {string} resumeId - Resume ID
 * @param {boolean} hard - Hard delete (permanently removes from DB and S3)
 * @param {boolean} force - Force delete even if resume has session references
 */
export const deleteResume = async (resumeId, hard = false, force = false) => {
  const params = {};

  if (hard) {
    params.hard = "true";
  }

  if (force) {
    params.force = "true";
  }

  const response = await api.delete(`/resumes/${resumeId}`, { params });
  return response.data;
};

/**
 * Get download URL for resume
 */
export const getResumeDownloadUrl = async (resumeId) => {
  const response = await api.get(`/resumes/${resumeId}/download`);
  return response.data;
};

/**
 * Restore a soft-deleted resume
 * @param {string} resumeId - Resume ID
 */
export const restoreResume = async (resumeId) => {
  const response = await api.post(`/resumes/${resumeId}/restore`);
  return response.data;
};

/**
 * Get list of soft-deleted resumes (can be restored)
 */
export const getDeletedResumes = async () => {
  const response = await api.get("/resumes/deleted");
  return response.data;
};

export default {
  getResumes,
  getResume,
  getPrimaryResume,
  uploadResume,
  setResumePrimary,
  reprocessResume,
  deleteResume,
  getResumeDownloadUrl,
  restoreResume,
  getDeletedResumes,
};
